import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { StyledEllipsis, StyledEllipsisTooltip } from './styled';
import { applyErrorFilter, errorDrilldown } from '@store/trends/base/actions';
import { INTERNAL_UNKNOWN } from '@utils/constants';
import { CopyOutlined } from '@ant-design/icons';
import { message } from 'antd';
import copy from 'copy-to-clipboard';
import { metricFilterErrorCodesSelector } from '@store/trends/base/selectors';
import apptracker from '@utils/sensor/apptracker';
import { TOGGLE_ERROR_FILTER } from '@src/utils/sensor/track';

function ErrorCell({ cellData, column, rowData }) {
  const dispatch = useDispatch();

  // highlight selected error code
  const errorCodeLookup = useSelector(metricFilterErrorCodesSelector);
  let isErrorCodeSelected = false;
  if (column.metric in errorCodeLookup) {
    isErrorCodeSelected = errorCodeLookup[column.metric].includes(cellData.join(''));
  }

  const handleClick = () => {
    if (!(rowData.disableDrilldown || rowData.value.join('') === INTERNAL_UNKNOWN)) {
      dispatch(errorDrilldown(rowData[column.key], column.metric));
    }
  };

  const handleFilterCLick = () => {
    if (!(rowData.disableDrilldown || rowData.value.join('') === INTERNAL_UNKNOWN)) {
      dispatch(applyErrorFilter(rowData[column.key], column.metric));
      apptracker(TOGGLE_ERROR_FILTER, { metric: column.metric });
    }
  };

  const handleCopy = (event) => {
    event.stopPropagation();
    if (copy(cellData)) {
      message.info('Copied to clipboard');
    }
  };

  return (
    <StyledEllipsis onClick={handleFilterCLick}>
      <StyledEllipsisTooltip text={cellData} selected={isErrorCodeSelected} />
      <CopyOutlined className="copy-cell-text" onClick={handleCopy} />
    </StyledEllipsis>
  );
}

export default ErrorCell;
